import { GETCUSTOMFIELD_SUCCESS, GETCUSTOMFIELD_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getCustomFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETCUSTOMFIELD_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETCUSTOMFIELD_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getCustomFieldReducer;
